export const PLATFORM_CREATE_SCHOOL_STEP_DESCRIPTIONS = [
  "Define core school identity and affiliation context.",
  "Capture official contact channels and school location.",
  "Create management admin profile and login identifiers.",
  "Set session structure and class baseline for onboarding.",
  "Enable operational modules and configure initial limits.",
  "Review all details before creating school and admin account.",
] as const;
